<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span id="products">
        <el-row :gutter="30">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Productos</h1></el-col>
        </el-row>
        <el-row :gutter="20">           

            <el-col :style="{'margin-bottom': '30px'}" :lg="18" :offset="3">
                <el-card class="box-card" >                    
                    <el-col :lg="12" :md="12" :sm="12" class="no-margins hidden-xs-only">
                        <div class="green-background">
                            <h5 class="products-tittles"><span class="circle-white"><font-awesome-icon icon="university" style="font-size:45px;margin-bottom:-10px; color:#3d8e95;" /></span><span class="fondo-white"><span class="consulta"> Consulta RUC</span></span></h5>
                            <p class="texto-consulta">Use la consulta RUC para conocer <br> los datos de cualquier empresa.</p>
                        </div>
                    </el-col>
                    <el-col :style="{'background-image': 'url(' + require('@/../public/assets/images/ruc.png') + ')', 'background-repeat': 'no-repeat', 'background-size':'100% 100%'}" :lg="12" :md="12" :sm="12" :xs="24"  class="text item card-with-backgound">                                                  
                        <el-input @keypress="isNumber()" type="text " placeholder="Escriba el número de RUC" v-model="Ruc" maxlength="11" class="ruc-display" show-word-limit></el-input>
                        <br>
                        <el-button class="ruc-button" @click="RucData()" type="primary" plain>Consultar</el-button>
                    </el-col>
                </el-card>
            </el-col>

            <el-col :style="{'margin-bottom': '30px'}" :lg="18" :offset="3">
                <el-card class="box-card" >                    
                    <el-col :lg="12" :md="12" :sm="12" class="no-margins hidden-xs-only">
                        <div class="green-background">
                            <h5 class="products-tittles">
                                <span class="circle-white">
                                    <font-awesome-icon icon="coins" style="font-size:45px;margin-bottom:-10px; color:#3d8e95;" />
                                </span>
                                <span class="fondo-white">
                                    <span class="consulta"> Obtener cambio SUNAT</span>
                                </span>
                            </h5>
                            <p class="texto-consulta">Obtenga el tipo de cambio SUNAT <br> de manera rápida y eficaz desde acá.</p>
                        </div>
                    </el-col>
                    <el-col :style="{'background-image': 'url(' + require('@/../public/assets/images/cambio.png') + ')', 'background-repeat': 'no-repeat', 'background-size':'100% 100%'}" :lg="12" :md="12" :sm="12" :xs="24"  class="text item card-with-backgound">                                                  
                        <el-button class="ruc-button-cambio" @click="CambioSunat()" type="primary" plain>Obtener cambio SUNAT</el-button>
                    </el-col>
                </el-card>
            </el-col>
            

            <!-- <el-col :lg="12">
                <el-card class="box-card">
                    <div class="text item">                           
                        <font-awesome-icon icon="coins" style="font-size:36px;" /><h5>Cambio Sunat</h5><br>         
                        <el-button @click="CambioSunat()" type="primary" plain>Obtener cambio SUNAT</el-button>
                    </div>
                </el-card>
            </el-col> -->
                      
        </el-row>
    </span>
</template>

<script>
import axios from 'axios';

export default {
    
    name: "Productos",  
    data () {
      return {
        Ruc: '',
        respuesta: null,   
        apiKey: "GmVr7hJwyo0s8SAEEj8n7COJfJhphlwLjp1My4JkSUGrARI5QLs1RV6z4wIx1v5M71Yjnctz0T/Y7P0R/DmxGEbfRHHrMV5AIc9mWAJt2vBk9YyaZwoBtgnNdCvWeZLKAIwI/qFKh9Ue78D/J9ON7eKqvMIG5283vcmR1tBOimC8aDbr4ixgm20FGVWIOyM7sMq/yapdx/IyOmQ+HAZWAf7PTaMnZdiR79Jti7btnvywEZPP0f7eSM8BUErq0JOUwxOltncwRYAuwpF+wasdCs0hN7zAbJu2ZFKJwRmd+RY=",   
        tittle: ""
      }
    },
    methods:{        
        async RucData () {
            if(this.Ruc === ''){
                this.$message.error('Es necesario que ingrese un RUC para devolver los datos')
            }else if(isNaN(this.Ruc)){
                this.$message.error('El ruc que ha ingresado es incorrecto')
            }else{
                this.$message.info('Espere un momento...')
                this.tittle = 'Datos de la empresa'       
                await axios
                    .get('https://ws.chevere.tech/demo/ConsultRuc/?q='+btoa(this.Ruc)+'&x='+this.apiKey)
                    .then(response =>                         
                        this.respuesta = response                            
                    ) 
                    .catch( e => console.log(e) )
                    if(this.respuesta.data === null || this.respuesta.data === ''){
                        this.respuesta.data = 'El Ruc ingresado no está registrado en la SUNAT'
                    }          
                    this.$alert(this.respuesta.data, this.tittle, {                        
                        confirmButtonText: 'OK',          
                    })
            }   
                    
        },
        async CambioSunat () {    
            this.$message.info('Espere un momento...') 
            this.tittle = 'Tipo de cambio SUNAT'       
            await axios
                .get('https://ws.chevere.tech/demo/ConsultTC?x='+this.apiKey)
                .then(response =>                         
                    this.respuesta = response                            
                ).catch( e => console.log(e) ) 
            
            this.$alert(this.respuesta.data, this.tittle, {
                confirmButtonText: 'OK',          
            });
        }
    }
}
</script>

<style scoped> 
    
    .texto-consulta{
        color:white;
        font-size:20px;
        padding-top: 35px;
    }
    .consulta{
        font-weight: 999;
        font-size: 24px;
        color: #3d8e95;
        margin-bottom:-7px;
    }
    .no-margins{
        margin:0;
        padding:0px !important;
    }
    .products-tittles{
        margin:0;
        padding-top: 80px;
    }
    .green-background{
        background: #3d8e95;
        max-height: 300px;
        max-width: 100%;
        height:300px;
    }
    .ruc-button{
        position:absolute;
        margin-top: 25px;
        margin-left: -9%;
        background: #550d77;
        color: white;
        border: 1px solid white;
        border-radius: 20px;
        min-width: 150px;
    }
    .ruc-button-cambio{
        position:absolute;
        margin-top: 115px;
        margin-left: -11%;
        background: #550d77;
        color: white;
        border: 1px solid white;
        border-radius: 20px;
        min-width: 150px;
    }
    .ruc-display{
        z-index: 2;
        padding-top: 120px;        
    }
    .card-with-backgound{
        position:relative;
    }
    .card-with-backgound {
        z-index: 1 !important;
        max-height: 300px;
        max-width: 100%;
        height:300px;
    }
    .box-card{        
        height: 300px;
        max-height: 300px;
        transition: transform .3s;      
    }
    div .el-card__header{
       padding: 5px !important; 
    }
    .box-card:hover{
        transform: scale(1.05);
    }
    .small-letter{
        font-size: 13px;
    }
    .fondo-verde{
        background:#3d8e95;
    }
    .circle-white{
        background: white;
        border-radius: 50%;
        padding: 25px;        
    }
    .fondo-white{
        background: white;
        border-radius: 0 40px 40px 0;
        padding: 16px 13px 10px 13px;        
    }
</style>





// WEBPACK FOOTER //
// src/sections/Productos.vue